import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const signaturesRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/signatures",
  component: lazyRouteComponent(
    () => import("@l30/web-documents/pages/signatures.page"),
    "SignaturesPage",
  ),
});
